import * as DropdownPrimitives from "@radix-ui/react-dropdown-menu";
export const FaDropdownMenuRadioGroup = DropdownPrimitives.RadioGroup;
